import React from 'react';
import { JdsButton } from './JdsButton';
import { MoreIcon } from './icons';

// Toggle "⋮" para o Dropdown do react-bootstrap: use com
// <Dropdown.Toggle as={JdsMoreToggle} />. Sem isso o Toggle renderiza um
// Button do Bootstrap (.btn .btn-link) e briga com o estilo do JdsButton.
export const JdsMoreToggle = React.forwardRef(function JdsMoreToggle(
  { variant = 'ghost', ...props },
  ref,
) {
  return (
    <JdsButton ref={ref} variant={variant} color="neutral" iconOnly {...props}>
      <MoreIcon />
    </JdsButton>
  );
});
